import React, { useState } from "react";
import "./createProject.css";
import Loader from "../MainComponent/loader";
import ProjectInfo from "./projectInfo";
import SideNav from "../../../component/sideNav";
import Header from "../../../component/header";

import { useDispatch } from "react-redux";
import { updateUserInfo } from "../../../Features/userInfo";

export default function CreateProject() {
  const dispatch = useDispatch();
  dispatch(updateUserInfo({ isAuth: true }));
  const [loader, setLoader] = useState(false);

  return (
    <>
      {loader && <Loader backgroundColor={"#000000db"}></Loader>}
      <div className="createProjectContainer">
        <Header></Header>
        <SideNav active="Dashboard" />
        <div className="createProjectContent">
          <ProjectInfo setLoader={setLoader}></ProjectInfo>
        </div>
      </div>
    </>
  );
}
